import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/biscuits/marie day biscuit.png";
import BiscuitImg from "../../../assets/products/biscuits/Marie-Day-Biscuits.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 30,
  },
  {
    grams: 50,
  },
  {
    grams: 100,
  },
  {
    grams: 200,
  },
];

export default function MarieProduct() {
  return (
    <>
      <Helmet>
        <title>
          Marie Day Biscuits – BearBitz | Premium Biscuits & Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz Marie Day Biscuits—delicate, lightly sweet, ideal for tea time. View pack sizes, cartons, and packaging specs for global standards."
        />
        <meta
          name="keywords"
          content="Marie Day Biscuits, BearBitz Marie Day Biscuits"
        />
        <link rel="canonical" href="https://www.bearbitz.in/biscuits/marie" />
        <meta property="og:title" content="Marie Day Biscuits – BearBitz" />
        <meta
          property="og:description"
          content="Light, buttery Marie Day biscuits with global-ready specs and premium presentation."
        />
      </Helmet>

      <ProductTemplate
        productTitle="MARIE DAY BISCUITS"
        productImage={BisImg}
        description="Relish the classic taste of Marie Biscuits, known for their light, crisp texture and mild sweetness. Perfect for dipping in tea or enjoying as a quick snack, these timeless biscuits bring simple joy to every moment, making them a favorite for all ages."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#C3A907"
        sectionBgColor="#EDE3A9"
        productBgcolor="#FFF6BE"
        tableheadBgcolor="#8F7B00"
        tableBgcolor="#FFFADE"
        footerBgcolor="#917C00"
      />
    </>
  );
}
